import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import Navigation from './Navigation';
import Logo from '../atoms/Logo';

const Holder = styled.div`
  display: none;
  padding: 1.5rem 1rem;
  @media(${props => props.theme.breakpoints.md}) {
    display: grid;
    grid-auto-flow: dense;
    grid-template-columns: 14rem 1fr auto;
    align-items: center;
  }
  @media(min-width: 1400px) {
    display: grid;
    grid-template-columns: 1fr 14rem 1fr;
  }
  > :first-child { 
    @media(min-width: 1400px) {
      grid-column: 2/3;
    }
  }
  > :nth-child(2) { 
    justify-self: end;
    align-self: start;
    @media(min-width: 1400px) {
      justify-self: start;
    }
  }
  > :last-child { justify-self: end; }
  p, ul {
    margin: 0;
  }
  li { line-height: 1; }
`;

function LargeHeader() {

  return (
    <Holder>
      <p><Link to="/"><Logo/></Link></p>
      <Navigation/>
      <p><Link to="/enquire" className="button">Enquire now</Link></p>
    </Holder>
  )
}

export default LargeHeader
